"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rudderStackReporter = void 0;
var sli_metrics_client_1 = require("@cvent/sli-metrics-client");
exports.rudderStackReporter = sli_metrics_client_1.rudderReporter;
